import type { Status, FilmSort } from '@/types/Filters'

export const Statuses:Status[] = [
    { value: null, label: "Все" },
    { value: "active", label: "Активный" },
    { value: "draft", label: "Неактивным" },
]

export const Sort:FilmSort[] = [
      {
        value: null,
        label: 'По умолчанию',
    },
    {
        value: 'title',
        label: 'По названию'

    },
    {
        value: 'release_year',
        label: 'По году выпуска'
    },
    {
        value: 'created_at',
        label: 'По дате добавления'
    }
] 